import { IStrategy, Leg } from "../../../types";
import { displayFeatures } from "./strategy-card-helper";
import PayOffGraph from "./pay-off";
import { useCallback, useState } from "react";
import ChartImage from "./../../../images/chart.svg";

interface IStrategyCardProps {
  data: IStrategy;
  index: number;
}
const StrategyCard = ({ data, index }: IStrategyCardProps) => {
  const [showPayOffGraph, setShowPayOffGraph] = useState(false);
  const { legs, title, alert } = data;
  const [expand, setExpand] = useState(false);

  const handlePayOffChange = useCallback(() => {
    setShowPayOffGraph(!showPayOffGraph);
    if (!showPayOffGraph) setExpand(false);
  }, [showPayOffGraph]);

  if (data)
    return (
      <div className="custom-card">
        <div className="card-header">
          <b>
            {index + 1}. {title}
          </b>
        </div>
        <div className="card-body">
          {legs.map((val: Leg, key: number) => {
            return (
              <div className="card-text" key={key}>
                {val.buy ? "Buy " : "Sell "}
                {Math.abs(val.quantity / (data.lotSize || 1))} lot of{" "}
                {val.strikePrice} {val.call ? "call " : "put "} @ {val.price}
              </div>
            );
          })}

          {alert && (
            <><span
              className="alert card-text"
              style={{ display: "inline-block" }}
              role="alert"
            >
              <b>Alert:</b> {alert}
            </span>
            <br />
            </>
          )}
          <img
            src={ChartImage}
            width={"38px"}
            height={"38px"}
            alt="chart"
            className="chart-icon"
            onClick={handlePayOffChange}
          />

          <div
            className="more-icon"
            onClick={() => {
              setExpand(!expand);
              if (!expand && showPayOffGraph) {
                setShowPayOffGraph(false);
              }
            }}
          >
            <span style={{ marginRight: "5px" }}>{expand ? "Less Details" : "More Details"}</span>
            {expand ? (
              <i className="bi bi-chevron-up"></i>
            ) : (
              <i className="bi bi-chevron-down"></i>
            )}
          </div>

          {expand && displayFeatures(data)}

          {showPayOffGraph && (
            <PayOffGraph
              width="100%"
              height="150px"
              strategy={data}
            ></PayOffGraph>
          )}
        </div>
      </div>
    );

  return <div></div>;
};
export default StrategyCard;
